module.exports = __webpack_public_path__ + "static/media/22ESCWA13.6b92e292.jpg";